import { FC } from 'react';
import { Control, Controller, useWatch } from 'react-hook-form';
import { FormValues } from '../../types';
import LogoUploadBox, {
  LogoPreviewBox,
  LogoPreviewBoxLogo,
} from 'components/new/LogoUploadBox';

export { LogoPreviewBox, LogoPreviewBoxLogo };

type Props = {
  name: 'lightMainLogo' | 'darkMainLogo' | 'squareLogo' | 'reportCoverLogo';
  boxVariant: 'light' | 'dark';
  control: Control<FormValues>;
  isCompact?: boolean;
  backgroundColor?: string;
  allowRemove?: boolean;
};

const LogoUploadBoxField: FC<Props> = ({
  name,
  boxVariant,
  control,
  isCompact,
  backgroundColor,
  allowRemove,
}) => {
  const value = useWatch({ control, name });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange } }) => (
        <LogoUploadBox
          value={value}
          onChange={onChange}
          boxVariant={boxVariant}
          isCompact={isCompact}
          backgroundColor={backgroundColor}
          allowRemove={allowRemove}
        />
      )}
    />
  );
};

export default LogoUploadBoxField;
